import { t } from '../i18n'
import { isApiError } from '../api/errors'

/**
 * Maps a failed `POST /filters/{id}/run` call to a user-facing message. The
 * raw `ApiError.message` for this endpoint can be internal/technical detail
 * not meant for end users — e.g. a `NotFoundException` message naming the
 * filter id, or Javalin's own catch-all 404 body ("No route matches POST
 * /api/v1/filters/{id}/run") when the request never reaches a registered
 * route. Branch on `status` instead of surfacing `message` directly; the raw
 * error is still logged in full by `normalizeError` (see api/errors.ts) for
 * debugging.
 */
export function filterRunErrorMessage(err: unknown): string {
  if (!isApiError(err)) return t('errors.filterRun.generic')

  switch (err.status) {
    case 401:
      return t('errors.filterRun.sessionExpired')
    case 403:
      return t('errors.filterRun.forbidden')
    case 404:
      return t('errors.filterRun.notFound')
    case 502:
    case 503:
      return t('errors.filterRun.unavailable')
    case 0:
      return t('errors.filterRun.offline')
    default:
      return t('errors.filterRun.generic')
  }
}
